import { CreateOrEditReleasePage } from "./CreateOrEditReleasePage";
interface EditReleasePageProps {
    releaseVersion: string;
    copiedRelease?: boolean;
}
export function EditReleasePage({ releaseVersion, copiedRelease }: EditReleasePageProps) {
    return <CreateOrEditReleasePage releaseVersion={releaseVersion} copiedRelease={copiedRelease}/>;
}
